import React, { useMemo } from 'react'

import { Switch } from '@mui/material'
import { useField } from 'formik'

import { WishAndExpectation, WishesToggleFieldContainerProps } from '../../../ana-toolbox'
import { wishesSettings } from '../../utils/config/wishes'
import { ToggleContainer } from '../../utils/shared/ToggleContainer'
import { ToggleFormControlLabel } from '../../utils/shared/ToggleFormControlLabel'
import { Translate } from '../translate/translate'

type WishesToggleFieldProps = Pick<WishesToggleFieldContainerProps, 'label'> & {
  name: string
  value?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

const WishesToggleFieldBase = ({ name, label, value, onChange }: WishesToggleFieldProps) => {
  return (
    <ToggleContainer>
      <ToggleFormControlLabel
        label={<Translate>{label}</Translate>}
        control={<Switch name={name} slotProps={{ input: { name } }} checked={value || false} onChange={onChange} />}
        labelPlacement="start"
      />
    </ToggleContainer>
  )
}

const addWish = (newWish: WishAndExpectation, wishes: WishAndExpectation[]): WishAndExpectation[] => [
  ...wishes,
  newWish,
]

const updateWish = (wishToUpdate: WishAndExpectation, wishes: WishAndExpectation[]): WishAndExpectation[] =>
  wishes.map((wish) => (wish.key === wishToUpdate.key ? wishToUpdate : wish))

export const WishesToggleField = ({ wishKey, label }: WishesToggleFieldContainerProps) => {
  const [props, _, helpers] = useField<WishAndExpectation[]>('wishesAndExpectations')

  const wishes = props.value || []
  const wish = props.value?.find(({ key }) => key === wishKey)

  const wishSettings = useMemo(() => wishesSettings[wishKey], [wishKey])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newWish = { key: e.target.name, flag: checked }
    const updatedWishes = wish ? updateWish(newWish, wishes) : addWish(newWish, wishes)

    helpers.setValue(
      wishSettings?.updateDependantWishes ? wishSettings.updateDependantWishes(newWish, updatedWishes) : updatedWishes
    )
  }

  return <WishesToggleFieldBase label={label} onChange={handleChange} value={wish?.flag} name={wishKey} />
}
